import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import CuentasBancarias from "features/Contactos/components/CuentasBancarias"
import Cesiones from "features/Validaciones/pages/Cesiones"
import Financiacion from "features/Validaciones/pages/Financiacion"
import { TFunction } from "i18next"
import AlbaranContatos from "../components/AlbaranContactos"
import Contabilidad from "../components/Contabilidad"
import FacturasContatos from "../components/FacturasContactos"
import PedidosContatos from "../components/PedidosContactos"
import Personalizados from "../components/Personalizados"
import Preferencias from "../components/Preferencias"
import PresupuestosContatos from "../components/PresupuestoContacto"
import Validaciones from "../components/Validaciones"

export const CONTACTO_TABS = {
  CONTABILIDAD: 0,
  PREFERENCIAS: 1,
  PERSONALIZADOS: 2,
  CUENTAS_BANCARIAS: 3,
  VALIDACIONES: 4,
  CESIONES: 5,
  FINANCIACION: 6,
  FACTURAS: 7,
  ALBARAN: 8,
  PEDIDO: 9,
  PRESUPUESTO: 10,
}

export const tabs = (t: TFunction) => {
  return [
    {
      items: [
        {
          key: CONTACTO_TABS.CONTABILIDAD,
          icon: "calculator",
          label: `${t("contactos.editar.dataAdvance.menuAccount")}`,
        },
        {
          key: CONTACTO_TABS.PREFERENCIAS,
          icon: "gear",
          label: `${t("contactos.editar.dataAdvance.menuPreference")}`,
        },
        {
          key: CONTACTO_TABS.PERSONALIZADOS,
          icon: "fa-tags",
          label: `${t("contactos.editar.dataAdvance.menuPersonaly")}`,
        },
        {
          key: CONTACTO_TABS.CUENTAS_BANCARIAS,
          icon: "university",
          label: `${t("contactos.editar.dataAdvance.menuCuentaBank")}`,
        },
      ],
    },
    {
      items: [
        {
          key: CONTACTO_TABS.FACTURAS,
          icon: "file-invoice",
          label: `${t("contactos.editar.dataAdvance.menuInvoces")}`,
        },
        {
          key: CONTACTO_TABS.ALBARAN,
          icon: "file-contract",
          label: `${t("contactos.editar.dataAdvance.menuDeliveryNote")}`,
        },
        {
          key: CONTACTO_TABS.PEDIDO,
          icon: "file-lines",
          label: `${t("contactos.editar.dataAdvance.menuOrder")}`,
        },
        {
          key: CONTACTO_TABS.PRESUPUESTO,
          icon: "file",
          label: `${t("contactos.editar.dataAdvance.menuQuotation")}`,
        },
      ],
    },
    {
      items: [
        {
          key: CONTACTO_TABS.VALIDACIONES,
          icon: "ballot-check",
          label: `${t("contactos.editar.dataAdvance.menuValidations")}`,
        },
      ],
    },
    {
      items: [
        {
          key: CONTACTO_TABS.CESIONES,
          icon: "arrow-right-arrow-left",
          label: `${t("contactos.editar.dataAdvance.menuCesiones")}`,
        },
        {
          key: CONTACTO_TABS.FINANCIACION,
          icon: "check-to-slot",
          label: `${t("contactos.editar.dataAdvance.menuFinanciacion")}`,
        },
      ],
    },
  ]
}

export const panels = (
  contactoByid: ContactoReadingDtoProps,
  updateContactoById: () => void
) => ({
  [CONTACTO_TABS.CONTABILIDAD]: <Contabilidad />,

  [CONTACTO_TABS.PREFERENCIAS]: <Preferencias id={contactoByid.id} />,

  [CONTACTO_TABS.PERSONALIZADOS]: (
    <Personalizados
      id={contactoByid.id}
      getContactoById={updateContactoById}
    />
  ),
  [CONTACTO_TABS.CUENTAS_BANCARIAS]: contactoByid.empresaContactoId && (
    <CuentasBancarias id={contactoByid.empresaContactoId} />
  ),
  [CONTACTO_TABS.VALIDACIONES]: <Validaciones id={contactoByid.id} />,

  [CONTACTO_TABS.CESIONES]: <Cesiones />,

  [CONTACTO_TABS.FINANCIACION]: <Financiacion />,
  [CONTACTO_TABS.FACTURAS]: <FacturasContatos contacto={contactoByid} />,
  [CONTACTO_TABS.ALBARAN]: <AlbaranContatos contacto={contactoByid} />,
  [CONTACTO_TABS.PEDIDO]: <PedidosContatos contacto={contactoByid} />,
  [CONTACTO_TABS.PRESUPUESTO]: <PresupuestosContatos contacto={contactoByid} />,
})

export const getFormaContactoOptions = (
  formaContacto: $TSMigrationFixMe,
  edit: $TSMigrationFixMe,
  markAsPrincipal: $TSMigrationFixMe,
  remove: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return [
    {
      label: `${t("contactos.editar.editFormContact")}`,
      icon: "pi pi-pencil",
      command: () => edit(formaContacto),
    },
    ...(formaContacto.principal
      ? []
      : [
          {
            label: `${t("contactos.editar.markPrincipal")}`,
            icon: "pi pi-star",
            className: "w-100",
            command: () => markAsPrincipal(formaContacto),
          },
        ]),
    {
      label: `${t("contactos.editar.deleteFormContat")}`,
      icon: "pi pi-trash",
      className: "[&>*:first-child>*:nth-child(1n)]:!tw-text-danger-20",
      command: () => remove(formaContacto.id),
    },
  ]
}
